module.exports = __webpack_public_path__ + "img/xdcj.15a2c773.png";